<template>
  <svg
    class="vue-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 113 128"
    data-name="Logo / Paypal / Monogram"
  >
    <path
      fill="#979797"
      d="M96.288 9.651C90.105 2.894 78.939 0 64.65 0H23.176a5.864 5.864 0 0 0-5.861 4.8L.045 109.852a3.462 3.462 0 0 0 3.517 3.948h25.6L27.4 124.548A3.03 3.03 0 0 0 30.474 128h21.583a5.13 5.13 0 0 0 5.127-4.2l.211-1.053 4.065-24.732.263-1.365a5.128 5.128 0 0 1 5.127-4.2h3.228c20.909 0 37.279-8.148 42.063-31.712 2-9.847.965-18.066-4.319-23.844a20.556 20.556 0 0 0-5.909-4.371c1.628-9.957-.011-16.731-5.626-22.868"
      data-name="Logo / Paypal / Light"
    />
    <path
      fill="#838383"
      d="M41.238 71.1h12.17c23.9 0 42.613-9.313 48.081-36.249.162-.8.3-1.57.424-2.33 1.628-9.957-.011-16.733-5.626-22.868C90.101 2.894 78.939 0 64.651 0H23.176a5.864 5.864 0 0 0-5.861 4.8L.045 109.849a3.463 3.463 0 0 0 3.517 3.951h25.6l6.439-39.125-.2 1.225a5.843 5.843 0 0 1 5.841-4.8"
      data-name="Logo / Paypal / Mild"
    />
    <path
      fill="#707070"
      d="M42.507 32.653a5.007 5.007 0 0 1 2.887-3.717 5.364 5.364 0 0 1 2.24-.487h32.511a70.519 70.519 0 0 1 10.726.749q1.408.216 2.737.5t2.582.633c.418.118.826.239 1.23.368a29.9 29.9 0 0 1 4.494 1.822c1.628-9.957-.011-16.733-5.626-22.87C90.105 2.894 78.939 0 64.65 0H23.176a5.866 5.866 0 0 0-5.861 4.806L.045 109.852a3.464 3.464 0 0 0 3.517 3.948h25.6L35.6 74.677Z"
      data-name="Tracé 43208"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconLogoPaypalMonogram',
};
</script>
